import { useQuery } from "@tanstack/react-query";
import { api, fmtDate } from "@/lib/api";
import { useSeo, PRIVATE_SEO } from "@/lib/seo";

export default function AdminVerificationsPage() {
  useSeo({ title: "Verifications | LUX", ...PRIVATE_SEO });
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "verifications"],
    queryFn: async () => (await api.get("/admin/verifications")).data,
  });
  return (
    <div className="space-y-5" data-testid="admin-verifications-page">
      <header>
        <p className="adm-label">Verifications</p>
        <h1 className="mt-2 text-3xl font-semibold text-admin-text">Verification records</h1>
        <p className="mt-1 text-sm text-admin-muted">{data?.note || "LUX stores only the result, date, provider reference and over-18 flag."}</p>
      </header>
      <section className="adm-card overflow-hidden">
        {isLoading ? <p className="p-5 text-sm text-admin-muted">Loading...</p> : (
          <div className="max-h-[70vh] overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-admin-surface2 text-xs uppercase text-admin-muted">
                <tr>
                  <th className="px-4 py-2 text-left font-semibold">Account</th>
                  <th className="px-4 py-2 text-left font-semibold">Kind</th>
                  <th className="px-4 py-2 text-left font-semibold">Result</th>
                  <th className="px-4 py-2 text-left font-semibold">Over 18</th>
                  <th className="px-4 py-2 text-left font-semibold">Provider ref</th>
                  <th className="px-4 py-2 text-left font-semibold">Completed</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-admin-border">
                {data?.verifications?.map((v, i) => (
                  <tr key={i} data-testid="admin-verifications-row">
                    <td className="px-4 py-2 text-admin-text">{v.account || "—"}{v.is_demo && <span className="adm-pill ml-2 border-admin-border bg-admin-surface2 text-admin-muted">Demo</span>}</td>
                    <td className="px-4 py-2 text-admin-text">{v.kind}</td>
                    <td className="px-4 py-2 text-admin-text">{v.result}</td>
                    <td className="px-4 py-2 text-admin-text">{v.is_over_18 === null ? "—" : v.is_over_18 ? "Yes" : "No"}</td>
                    <td className="px-4 py-2 font-mono text-xs text-admin-muted">{v.provider_ref}</td>
                    <td className="px-4 py-2 text-xs text-admin-muted">{v.completed_at ? fmtDate(v.completed_at, true) : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
